import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SiteLayout from "./components/site/SiteLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Books from "./pages/Books";
import Journalism from "./pages/Journalism";
import Speaking from "./pages/Speaking";
import Foundation from "./pages/Foundation";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "./App.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/books" element={<Books />} />
            <Route path="/journalism" element={<Journalism />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="/foundation" element={<Foundation />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#F9F6F0",
            color: "#1A1A1A",
            border: "1px solid #DCD7CC",
            borderRadius: 0,
            fontFamily: "Satoshi, Manrope, sans-serif",
          },
        }}
      />
    </>
  );
}

export default App;
